// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
// import get from 'lodash/get';

export default function(state = {}, action) {
  // const { store } = action;
  const typeMap = {
    MAGAZINE_LATEST_ISSUE_POSTS_LOADING() {
      return {
        isLoading: true,
        magazineLatestIssuePosts: action.magazineLatestIssuePosts
      };
    },
    MAGAZINE_LATEST_ISSUE_POSTS_LOADED() {
      return {
        isLoading: false,
        data: action.magazineLatestIssuePosts
      };
    },
    MAGAZINE_LATEST_ISSUE_POSTS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineLatestIssuePosts.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
